import * as PaymentMethodConstants from './paymentMethodConstant';

export const paymentMethodText = [
    {
        text: 'Pay Later At Counter',
        value: PaymentMethodConstants.PayLaterAtCounter,
        imageSrc: '/img/payment-method-pay-later-at-counter-logo.png'
    },
    { text: 'E-Payment', value: PaymentMethodConstants.EPayment, imageSrc: '/img/payment-method-e-payment-logo.png' }
];
